class FilteredProductList extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.hasLoaded = false;
  }

  connectedCallback() {
    this.sectionId = this.getAttribute('section-id');
    this.collectionUrl = this.getAttribute('collection-url');
    this.parameters = new URLSearchParams();
    this.productId = this.getAttribute('product-id');
    this.rteFormatter = this.querySelector('rte-formatter');
    this.minimumVisible = Number(this.getAttribute('minimum-visible')) || 0;
    this.maximumVisible = Number(this.getAttribute('maximum-visible')) || 20;

    if (Number.isNaN(this.minimumVisible)) {
      this.minimumVisible = 0;
    }

    const filterParameters = this.getAttribute('filters')?.split(',') ?? [];

    for (const param of filterParameters) {
      const [key, value] = param.split('=');

      if (!key || !value) {
        continue;
      }

      this.parameters.append(key, value);
    }

    this.parameters.set('section_id', this.sectionId);
    this.parameters.set('filter.v.availability', 1);

    if (filterParameters.length > 0) {
      this.setupObserver();
    }
  }

  setupObserver() {
    const options = {
      root: null, // viewport
      rootMargin: '20% 0px', // trigger 20% before entering viewport
      threshold: 0,
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.hasLoaded) {
          this.hasLoaded = true;
          this.loadContent();
          this.observer.disconnect();
        }
      });
    }, options);

    this.observer.observe(this);
  }

  async loadContent() {
    try {
      const url = `${this.collectionUrl}?${this.parameters.toString()}`;
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      const shopifySection = this.closest('.shopify-section');

      const clone = document.createElement('div');

      clone.innerHTML = html;

      const productItems = new Map([...clone.querySelectorAll(`product-card`)].map((e) => [e.dataset.productId, e]));
      const viewAllButton = clone.querySelector('[class*="product_list_button"]');
      const rteFormatter = clone.querySelector('rte-formatter');

      for (let i = 0; i < productItems.size; i++) {
        const [id, product] = [...productItems.entries()][i];
        const removeItem = id === this.productId || (i === productItems.size - 1 && !productItems.has(this.productId) && productItems.size > this.maximumVisible);

        if (removeItem) {
          const parent = product.closest('.resource-list__slide') ?? product.closest('.resource-list__item');
          parent.remove();
          productItems.delete(id);
        }
      }

      if (viewAllButton) {
        this.parameters.delete('section_id');
        viewAllButton.href = [this.collectionUrl, this.parameters.toString()].join('?');
      }

      if (this.rteFormatter && rteFormatter) {
        rteFormatter.outerHTML = this.rteFormatter.outerHTML;
      }

      if (shopifySection) {
        shopifySection.outerHTML = productItems.size >= this.minimumVisible ? clone.innerHTML : '';
      }
    } catch (error) {
      console.error('Failed to load filtered products:', error);
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

if (!customElements.get('filtered-product-list')) {
  customElements.define('filtered-product-list', FilteredProductList);
}
